/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import areasReducer from './reducers/areas';
import permitReducer from './reducers/permit';
import reservationReducer from './reducers/reservation';
import validationReducer from './reducers/validation';
import pendingReservationReducer from './reducers/pendingReservation';
import availabilityReducers from './reducers/availability';
import cartReducer from './reducers/cart';
import seasonReducer from './reducers/season';

const PERSIST_KEY = 'VEHICLE_PERMITS';

const getPersistConfig = (namespace, hard) => {
    const config = {
        key: `${PERSIST_KEY}:${namespace}`,
        storage,
    };

    if (hard) {
        config.stateReconciler = hardSet;
    }

    return config;
};

const vehiclePermitReducer = {
    permit: permitReducer,
    areas: areasReducer,
    season: seasonReducer,
    reservation: reservationReducer,
    validation: validationReducer,
    cart: cartReducer,
    availability: availabilityReducers,
    pendingReservations: persistReducer(
        getPersistConfig('pendingReservations', true),
        pendingReservationReducer
    ),
};

export default combineReducers(vehiclePermitReducer);
